// 配置编译环境和线上环境之间的切换
const env = process.env;
// 设置接口请求域名为cloud
// const baseUrl = window.location.origin;
// const baseUrl = window.location.origin.replace('dot-admin', 'cloud');
let baseUrl;
const url = window.location.href;
if (url.includes('.qa')) {
  baseUrl = 'https://cloud.qa.iol8.net';
} else if (url.includes('.dev')) {
  baseUrl = 'https://cloud.dev.iol8.net';
} else if (url.includes('.release')) {
  baseUrl = 'https://cloud.release.iol8.net';
} else {
  baseUrl = window.location.origin.replace('dot-admin', 'cloud');
}

let previewUrl = `${baseUrl}/file/fileview/preview?fileUrl=`;

// 图表库为avue套地址
const iconfontVersion = [
  '567566_qo5lxgtishg',
  '667895_v7uduh4zui',
  '2770648_8c2ps52k1kw',
  '3208780_oqjijramamc',
  '3208780_9e1uxvmnzsb',
  '3208780_8ihxnket4y5',
  '3208780_f01umik8hxw',
];
const iconfontUrl = `//at.alicdn.com/t/font_$key.css`;
// myIconfont[0]，iconfront地址传承已遗失，所以新的图标新建了库，即myIconfont[1]
const myIconfont = ['3996263_k3j392tc47', '3996263_gcw3ahrqwct']; //at.alicdn.com/t/c/font_3996263_gcw3ahrqwct.js
const myIconfontUrl = `//at.alicdn.com/t/c/font_$key.css`;
const codeUrl = `${baseUrl}/code`;
// const downUrl = 'https://preview.e7yi.com/?url={0}&attname={1}&method=down'
const downUrl = `${baseUrl}/file/batchDownload/down?fileUrl={0}&fileName={1}`;
export {
  baseUrl,
  iconfontUrl,
  iconfontVersion,
  myIconfont,
  myIconfontUrl,
  codeUrl,
  env,
  previewUrl,
  downUrl,
};
